import { OorTitle } from './api'
import { OORRecipient } from './types'
import {
  PossibleOorRecipientDto,
  PossibleOorRecipientsResponseDto
} from '@/api/origin-workflow-svc'

/**
 * Converts an array of ProposedRecipientDto objects to an array of Recipient objects.
 *
 * @param {ProposedRecipientDto | null | undefined} proposedRecipientDto - The DTO to convert.
 * @returns {OORRecipient[]} - The array of converted Recipient objects.
 */
export const convertProposedRecipientDto = (
  proposedRecipientDto: PossibleOorRecipientsResponseDto | null | undefined
): OORRecipient[] => {
  if (
    !proposedRecipientDto ||
    !proposedRecipientDto.recipients ||
    proposedRecipientDto.recipients.length === 0
  ) {
    return []
  }

  const AllUsers: OORRecipient[] = []

  proposedRecipientDto.recipients.map((user) =>
    (user.titleAndGrantStatusList ?? []).map((titleAndGrantStatus) => {
      const title = titleAndGrantStatus.title ?? ''
      if (
        title.toLowerCase() !== 'employee' &&
        title.toLowerCase() !== 'lar' &&
        title.toLowerCase() !== 'dar' &&
        title.toLowerCase() !== 'qar'
      )
        AllUsers.push({
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          email: user.emails?.[0] || '',
          orgName: user.orgName || '',
          oorTitle: title,
          shortTitle: titleAndGrantStatus.shortTitle,
          status: titleAndGrantStatus.grantStatus || '',
          error: null,
          userId: user.userId
        })
    })
  )
  return AllUsers
}

export const findOorTitleByGrant = (
  oorTitles: OorTitle[] | null | undefined,
  grants: Array<string | null> | null | undefined
): OorTitle[] => {
  const OORTitles: OorTitle[] = []
  if (!oorTitles || !grants) {
    return OORTitles
  }
  for (const grant of grants) {
    if (grant == null) {
      continue
    }

    const foundTitle = oorTitles.find(
      (oorTitle) => oorTitle.title?.toLowerCase() === grant.toLowerCase()
    )

    if (foundTitle) {
      OORTitles.push(foundTitle)
    }
  }

  return OORTitles
}

export function isRecipient(
  userId: string,
  recipient: PossibleOorRecipientDto[]
): boolean {
  return !!recipient.some((x) => x.userId === userId)
}
